import { useQuery } from '@tanstack/react-query';
import { AfterShipResponse } from 'api/aftership/types';
import { apiRoutes } from 'constants/routes';
import { fetcher, FetcherError } from 'shared/utils/fetcher';
import { useStoreValue } from './useStore';

export const useAfterShipTracking = (trackingNumber: string) => {
  const store = useStoreValue();

  return useQuery({
    queryKey: ['aftership', store, trackingNumber],
    queryFn: async () => {
      try {
        const { data } = await fetcher.get<AfterShipResponse>(
          apiRoutes.aftership.tracking({ id: trackingNumber, store })
        );
        return data;
      } catch (e) {
        // 404 just means the tracking number is not found. No need to throw an
        // error.
        if (e instanceof FetcherError && e.status === 404) {
          return null;
        }
        throw e;
      }
    },
    enabled: !!trackingNumber
  });
};
